"use client";

import cn from "@utils/cn";
import { isEventExpired, sanitizeEventCardData } from "@utils/eventPageUtils";
import { useTranslations } from "next-intl";
import React, { useMemo, useState } from "react";

import ForSalesCard from "../Forsale/ForSalesCard";

interface Props {
  pageTypeData?: any[];
  [key: string]: any;
}

type EventTabKey = "all" | "active" | "past";

const EventPageTab = ({ pageTypeData }: Props) => {
  const t = useTranslations();
  const [activeTab, setActiveTab] = useState<EventTabKey>("all");
  const events = useMemo(() => pageTypeData?.map((item: any) => sanitizeEventCardData(item)) ?? [], [pageTypeData]);

  const filteredEvents = useMemo(() => {
    if (activeTab === "active") return events.filter((event) => !isEventExpired(event.eventDate));
    if (activeTab === "past") return events.filter((event) => isEventExpired(event.eventDate));
    return events;
  }, [events, activeTab]);

  const tabs: { key: EventTabKey; label: string }[] = [
    { key: "all", label: t("all-events") || "All Events" },
    { key: "active", label: t("active-events") || "Active Events" },
    { key: "past", label: t("past-events") || "Past Events" },
  ];

  if (!events.length) return null;

  return (
    <div className="py-l">
      <div className="flex items-center justify-center mb-l">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            className={cn(
              "pb-s px-s -mb-px border-b-2 text-m font-secondary-light transition-colors border-b border-gray-10 capitalize",
              activeTab === tab.key ? "border-black text-black font-medium" : "text-gray-50",
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="px-l md:p-0 md:w-20\/24 md:mx-auto md:grid md:grid-cols-4 md:gap-l">
        {filteredEvents.map((event) => (
          <ForSalesCard
            key={event.id ?? event.slug}
            title={event.title}
            description={event.description}
            image={event.image}
            slug={event.slug}
            eventDate={event.eventDate}
            eventLocaltion={event.eventLocaltion}
          />
        ))}
      </div>
    </div>
  );
};

export default EventPageTab;
